import { requestsReducer } from 'redux-saga-requests';
import {
  GET_ORGANIZATIONS,
  GET_ORGANIZATION,
  GET_ORGANIZATION_DEVICES,
  GET_AUDIT_ORGANIZATIONS,
  GET_SLACK_CHANNEL,
} from '../constants';

export const organizationsReducer = requestsReducer({
  actionType: GET_ORGANIZATIONS,
  multiple: true,
  getData: (state, action) => action.payload.data.content,
});

export const organizationReducer = requestsReducer({
  actionType: GET_ORGANIZATION,
  getData: (state, action) => action.payload.data.content,
});

export const auditOrganizationsReducer = requestsReducer({
  actionType: GET_AUDIT_ORGANIZATIONS,
  getData: (state, action) => action.payload.data.content,
});

export const slackChannelReducer = requestsReducer({
  actionType: GET_SLACK_CHANNEL,
  getData: (state, action) => action.payload.data.content,
  resetOn: [GET_SLACK_CHANNEL],
});

export const organizationDevicesReducer = requestsReducer({
  actionType: GET_ORGANIZATION_DEVICES,
  multiple: true,
  getData: (state, action) => action.payload.data.content,
});
